import { gql } from 'apollo-angular';

export const syncAllQuery = gql`
  query Query {
    sync_all
  }
`;

export const syncAllMenuQuery = gql`
  query Query {
    sync_all_menu
  }
`;

export const cloudSyncQuery = gql`
  query Cloud_sync {
    cloud_sync {
      status
    }
  }
`;
